import React, { useEffect } from 'react';
import { SignIn } from '@clerk/react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LogoFull } from '../components/Logo';

const G = '#004D35';
const BORDER = '#e8e5e0';
const BG = '#f5f3ef';

const SignInPage = () => {
  const { isAuthenticated, isLoading, user, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoading || !isAuthenticated || !user || error) return;
    const role = user.role;
    if (role === 'admin') navigate('/admin', { replace: true });
    else if (role === 'advisor') navigate('/advisor-portal', { replace: true });
    else navigate('/onboarding', { replace: true });
  }, [isLoading, isAuthenticated, user, error, navigate]);

  return (
    <div style={{ minHeight: '100vh', background: BG }}>
      <nav style={{
        background: '#fff',
        borderBottom: `1px solid ${BORDER}`,
        padding: '0 40px',
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}>
        <Link to="/" style={{ textDecoration: 'none' }}>
          <LogoFull size={26} />
        </Link>
        <Link
          to="/"
          style={{ fontSize: 13, fontFamily: 'sans-serif', color: '#aaa', textDecoration: 'none' }}
          onMouseEnter={e => e.target.style.color = '#555'}
          onMouseLeave={e => e.target.style.color = '#aaa'}
        >
          ← Back to home
        </Link>
      </nav>

      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 'calc(100vh - 56px)',
        padding: '40px 24px',
      }}>
        <div style={{ width: '100%', maxWidth: 480 }}>
          <div style={{ marginBottom: 24, textAlign: 'center' }}>
            <LogoFull size={28} />
          </div>
          <p style={{ color: '#58665d', fontSize: 13, textAlign: 'center', lineHeight: 1.6, marginBottom: 20 }}>
            Previously had a Viysr account? With our new login, you may need to{' '}
            <Link to="/sign-up" style={{ color: G, fontWeight: 600 }}>create a login</Link>
            {' '}using the same approved email. Your advisor profile is preserved.
          </p>
          <SignIn
            routing="path"
            path={location.pathname.startsWith('/sign-in') ? '/sign-in' : '/login'}
            signUpUrl="/sign-up"
            fallbackRedirectUrl="/onboarding"
            appearance={{
              variables: {
                colorPrimary: G,
                colorPrimaryForeground: '#ffffff',
                borderRadius: '12px',
                fontFamily: 'sans-serif',
              },
              elements: {
                card: {
                  boxShadow: '0 8px 40px rgba(0,0,0,0.08)',
                  border: `1px solid ${BORDER}`,
                  borderRadius: 20,
                },
                headerTitle: { fontFamily: 'Georgia, serif', color: '#0a1a0f' },
                formButtonPrimary: {
                  background: G,
                  borderRadius: 999,
                  fontWeight: 700,
                },
                footerActionLink: { color: G },
              },
            }}
          />
          {error && <p role="alert" style={{ color: '#b42318', textAlign: 'center' }}>{error}</p>}
          <p style={{
            textAlign: 'center',
            marginTop: 20,
            fontSize: 13,
            fontFamily: 'sans-serif',
            color: '#aaa',
          }}>
            Don't have an account?{' '}
            <Link to="/get-started" style={{ color: G, fontWeight: 600, textDecoration: 'none' }}>
              Get started →
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignInPage;
